exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".overlay-content{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.7)}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/Overlay/style.css"],"names":[],"mappings":"AAAA,iBACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,+BAAqC,CACtC","file":"style.css","sourcesContent":[".overlay-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Components/Overlay/style.css
// module id = 380
// module chunks = 0 4 8